module.exports = __webpack_public_path__ + "img/logo.9e46aae8.png";